import { apiService } from 'core/services/apiService';

export interface HolidayCalendarItem {
	/** API field: date of the holiday (YYYY-MM-DD) */
	holiday_date?: string;
	name?: string;
	title?: string;
	day?: string;
	description?: string | null;
	type?: string;
	state?: string;
	country?: string;
	[key: string]: unknown;
}

export interface HolidayCalendarResponse {
	member?: HolidayCalendarItem[];
	'hydra:member'?: HolidayCalendarItem[];
}

/**
 * Fetches holiday/off-day calendar for a date range (month-based).
 * API: /common/holiday_calendar?page=1&itemsPerPage=10&pagination=false&from_date=YYYY-MM-DD&to_date=YYYY-MM-DD
 */
export const fetchHolidayCalendar = async ({
	from_date,
	to_date,
}: {
	from_date: string;
	to_date: string;
}): Promise<HolidayCalendarItem[]> => {
	const response = await apiService.get<HolidayCalendarResponse>('/common/holiday_calendar', {
		params: {
			page: 1,
			itemsPerPage: 500,
			pagination: false,
			from_date,
			to_date,
		},
	});
	const data = response?.data;
	const list =
		Array.isArray(data) ? data : data?.member ?? data?.['hydra:member'] ?? [];
	return Array.isArray(list) ? list : [];
};
